module.exports = __webpack_public_path__ + "img/warning.e9f20524.svg";